"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _IconButton = require("./IconButton");

var _IconButton2 = _interopRequireDefault(_IconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _IconButton2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-icon-button@0.0.8@@alicd/crui-icon-button/lib/index.js
// module id = 632
// module chunks = 0